<template>
  <div id="evalholder" :class="{ firstchapter: currentchapter == 0 }">
    <h1 class="text-center" v-if="evalformdata != undefined && evalformdata.personevalid === null">
      {{ translation(14457) }}
    </h1>
    <XVactionbar v-if="evalformdata != undefined">
      <template slot="actionbuttons">
        <button
          v-if="getUrlReferrer() && evalformdata.personevalid !== null"
          @click.prevent="gotoUrlReferrer()"
          class="btn btn-primary btn-xs"
        >
          <span class="glyphicon glyphicon-chevron-left">&nbsp;</span>
          {{ translation(14324) }}
        </button>
        <button onclick="window.close()" v-if="evalformdata.personevalid === null" class="btn btn-primary btn-xs">
          <span class="glyphicon glyphicon-chevron-left">&nbsp;</span>
          {{ translation(17) }}
        </button>
      </template>
    </XVactionbar>
    <div class="evalheaderholder" v-if="show && currentchapter == 0">
      <!-- <pre>{{$v.form}}</pre> -->
      <div class="evaliconholder">
        <font-awesome-icon :icon="['fa', 'clipboard-list']" size="2x" />
      </div>
      <div class="evalpadding">
        <h1 class="clearpadmar">{{ evalformdata.tblEvaluationFormNameText }}</h1>
        <h3 class="clearpadmar" v-if="evalformdata.courseTitle !== ''" v-html="evalformdata.courseTitle"></h3>
        <p
          class="clearpadmar"
          v-if="evalformdata.tblEvaluationFormHeaderText !== ''"
          v-html="evalformdata.tblEvaluationFormHeaderText"
        ></p>
      </div>
      <evaldowntrans :duration="800">
        <div class="bckcol-primary evalbottombar"></div>
      </evaldowntrans>
    </div>
    <div class="personheaderholder" v-if="show && currentchapter == 0 && evalformdata.personName">
      <div class="evaliconholder">
        <font-awesome-icon :icon="['fa', 'user']" size="2x" />
      </div>
      <div class="evalpadding">
        <h1 class="clearpadmar">{{ evalformdata.personName }} {{ evalformdata.datefilledMSF | formatDate }}</h1>
      </div>
      <div class="evalbottombar bckcol-primary"></div>
    </div>
    <div v-if="showchapter && !evaldone">
      <div v-for="chapter in computedchapters" :key="chapter.chapterindex">
        <div class="chapterheaderholder">
          <div class="evaliconholder">
            <i class="fa fa-book evalicon"></i>
          </div>
          <div class="evalpadding">
            <h1 class="clearpadmar" v-html="chapter.tblChapterNameTextID"></h1>
            <p class="clearpadmar" v-html="chapter.tblChapterHeaderTextID"></p>
          </div>
          <div class="evalbottombar bckcol-primary"></div>
        </div>
        <evaltrans :duration="{ enter: 1500, leave: 200 }">
          <div class="chapterholder">
            <!-- ISSUE: PE-17195 koptekst voor horizontalradiolist apart van de vraag -->
            <brow
              class="evalvraagrow"
              :colsize="[4, wXS ? 8 : 7, wXS ? 2 : 1]"
              v-for="item in questions[chapter.chapterindex]
                .filter(
                  (item) =>
                    !istriggerquestion(item.tblQuestionID, chapter.chapterindex) ||
                    questionchoice[item.questionindex].questiontriggered === true
                )
                .slice(0, 1)"
              :rowindex="item.questionindex + 'Header'"
              v-bind:key="item.questionindex + 'Header'"
              v-show="item.tblquestiontypecode == 'horizontalradiolist'"
            >
              <component
                :tabindex="item.questionindex + 1"
                :is="getcomp(item.tblquestiontypecode)"
                :id="'header' + item.tblQuestionID"
                :formdata="{
                  chapterindex: chapter.chapterindex,
                  index: item.questionindex,
                  onlyHeader: true,
                  tblQuestionShowHeader: true,
                }"
                v-bind="
                  getproperties(item.tblquestiontypecode, item.tblQuestionID, item.questionindex, chapter.chapterindex)
                "
              ></component>
            </brow>

            <!-- wXS ? 6:7  betekend als op bootstrap XS dan kolom size is 6 anders 7 -->
            <brow
              class="evalvraagrow"
              :colsize="[4, wXS ? 8 : 7, wXS ? 2 : 1]"
              v-for="item in questions[chapter.chapterindex].filter(
                (item) =>
                  !istriggerquestion(item.tblQuestionID, chapter.chapterindex) ||
                  questionchoice[item.questionindex].questiontriggered === true
              )"
              :rowindex="item.questionindex.toString()"
              v-bind:key="item.questionindex"
              :labeltext="composeQuestion(item)"
              :helptext="item.tblQuestionDescriptionText"
              :labelfor="'vraag' + item.tblQuestionID"
              :haserror="$v.questionchoice[item.questionindex].$error"
              :helpcollapse="true"
              helpicon="fa fa-info-circle"
              helpicontext="klik voor meer info"
            >
              <evalfadetrans :duration="300">
                <span
                  class="evalnvttekst"
                  v-show="questionchoice[item.questionindex].nvt && evalformdata.datefilled === null"
                  >{{ translation(14320) }}</span
                >
              </evalfadetrans>

              <evaltrans :duration="300">
                <component
                  :tabindex="item.questionindex + 1"
                  :is="getcomp(item.tblquestiontypecode)"
                  :id="'vraag' + item.tblQuestionID"
                  :focus="item.questionindex === 0"
                  :formdata="{
                    chapterindex: chapter.chapterindex,
                    index: item.questionindex,
                    tblQuestionShowHeader:
                      item.tblQuestionShowHeader == 1 && item.tblquestiontypecode != 'horizontalradiolist'
                        ? true
                        : false,
                  }"
                  v-bind="
                    getproperties(
                      item.tblquestiontypecode,
                      item.tblQuestionID,
                      item.questionindex,
                      chapter.chapterindex
                    )
                  "
                  v-show="!questionchoice[item.questionindex].nvt || evalformdata.datefilled !== null"
                  v-model="questionchoice[item.questionindex].value"
                  v-on:formvaluechanged="formvaluechanged"
                  :disabled="evalformdata.datefilled !== null"
                ></component>
              </evaltrans>
              <span slot="errormessages" v-if="$v.questionchoice[item.questionindex].value !== undefined">
                <span class="form-group__message" v-if="!$v.questionchoice[item.questionindex].value.required"
                  >{{ translation(14321) }}.</span
                >
                <span
                  class="form-group__message"
                  v-if="
                    $v.questionchoice[item.questionindex].value.isnumeric !== undefined &&
                    !$v.questionchoice[item.questionindex].value.isnumeric
                  "
                  >{{ translation(3599) }}.</span
                >
                <span
                  class="form-group__message"
                  v-if="
                    $v.questionchoice[item.questionindex].value.minmaxnumber !== undefined &&
                    !$v.questionchoice[item.questionindex].value.minmaxnumber
                  "
                >
                  {{ translation(16580) }}
                  {{ $v.questionchoice[item.questionindex].value.$params.minmaxnumber.data[0] }}
                  {{ translation(16581) }}
                  {{ $v.questionchoice[item.questionindex].value.$params.minmaxnumber.data[1] }}
                  {{ translation(16582) }}
                  {{ translation(3599) }}
                </span>
              </span>
              <span slot="col3" class="pull-left" v-if="item.tblQuestionchapterObligatory && item.tblQuestionchapterNA">
                <div class="squaredFour">
                  <input
                    :id="'vinkjenvt' + item.questionindex"
                    type="checkbox"
                    :disabled="evalformdata.datefilled !== null"
                    v-model="questionchoice[item.questionindex].nvt"
                    v-on:change="nvtchangedclick(item.tblQuestionID, item.questionindex, chapter.chapterindex)"
                  />
                  <label :for="'vinkjenvt' + item.questionindex"></label>
                </div>
                <span class="nvttext">{{ translation(14327) }}</span>
              </span>
            </brow>
          </div>
        </evaltrans>
        <div class="chapterheaderholder">
          <div class="evalpadding">
            <p class="clearpadmar" v-html="chapter.tblChapterFooterTextID"></p>
          </div>
          <div class="evalbottombar bckcol-primary"></div>
        </div>
      </div>
    </div>

    <evalfooter
      v-if="evalformdata != undefined && !evaldone"
      v-show="showchapter"
      :chapterindex="1"
      v-on:validate="validate"
    ></evalfooter>

    <evaldowntrans :duration="1000">
      <evalfinish v-if="evaldone"></evalfinish>
    </evaldowntrans>
  </div>
</template>
<script>
import { EventBus, util, xValidation, FAMixin } from 'pevueglobal'
import {
  ZoomYTransition as evaldowntrans,
  SlideYDownTransition as evaltrans,
  FadeTransition as evalfadetrans,
} from 'vue2-transitions'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { questiontypes } from './evalquestiontypes'

import evalfinish from './evalfinish.vue'
import evalfooter from './evalfooter.vue'

export default {
  name: 'evaluaties',
  mixins: [FAMixin],
  data: function () {
    return {
      show: false,
      showchapter: false,
      valmessageid: null,
    }
  },
  props: {
    type: {
      type: Number,
    },
    formid: {
      type: Number,
    },
    init: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('evalstore', [
      'currentchapter',
      'evaldone',
      'chapters',
      'evalformdata',
      'questionchoice',
      'questionanswers',
      'questions',
      'validationtriggered',
      'currentchapter',
      'istriggerquestion',
    ]),
    computedchapters: function () {
      if (this.evalformdata.chaptersOnOnePage === 1) {
        return this.chapters
      } else {
        let chapters = []
        chapters.push(this.chapters[this.currentchapter])
        return chapters
      }
    },
  },
  methods: {
    ...mapActions('evalstore', ['getevaldata', 'nvtchanged', 'saveformvalue', 'nextchapter', 'getTexten']),
    ...mapMutations('evalstore', [
      'setvalidationtriggered',
      'RESET',
      'prevchapter',
      'questiontriggered',
      'setstatetriggerquestion',
      'triggervalidation',
    ]),
    ...mapMutations(['addNotification']),
    validateformmobile(titel, notiftext, anchor, anchortext) {
      window.goToByScroll(anchor)
      let htmlMsg = `${notiftext} <br> <a nohref class="fakelink" onclick="$.gritter.remove(window.valmessageid);window.valmessageid=null; goToByScroll('${anchor}'); return false">${anchortext}</a> `
      this.addNotification({
        groupname: 'warning',
        message: htmlMsg,
      })
    },
    getUrlReferrer: util.getUrlReferrer,
    gotoUrlReferrer: util.gotoUrlReferrer,
    initialize: function () {
      if (this.$route.name === 'evalformid') {
        if (this.$route.params.previewvalidations === 'false') {
          // preview voor beheer, kan geen gevens invullen en validaties staan uit zodat men erdoor heen kan bladeren
          this.getevaldata({
            myguid: '00000000-0000-0000-0000-000000000000',
            type: this.$route.params.type,
            formid: this.$route.params.formid,
            readonly: true,
          })
        } else {
          // preview button mode voor superadmin, kan gevens invullen en validaties staan aan zodat je het hele form kan testen
          this.getevaldata({
            myguid: '00000000-0000-0000-0000-000000000000',
            type: this.$route.params.type,
            formid: this.$route.params.formid,
            readonly: false,
          })
        }
      } else if (this.$route.name === 'eval' || this.$route.name === 'evalprofgroupid') {
        // evaluatie voor user
        this.getevaldata({
          myguid: this.$route.params.guid,
          type: this.$route.params.type,
          formid: 0,
        })
      } else if (this.$route.name === 'evalread') {
        // evaluatie voor user na invullen, readonly
        this.getevaldata({
          myguid: this.$route.params.guid,
          type: this.$route.params.type,
          formid: 0,
          readonly: true,
        })
      } else {
        this.getevaldata({
          myguid: '00000000-0000-0000-0000-000000000000',
          type: this.type,
          formid: this.formid,
          readonly: true,
        })
      }
    },
    goback: function () {
      window.history.back()
    },
    getproperties: function (questiontype, questionID, index, chapterindex) {
      var proplist = {}
      if (
        questiontypes[questiontype].type === 'XVradiobuttonlist' ||
        questiontypes[questiontype].type === 'XVradiobuttonlistHorizontal' ||
        questiontypes[questiontype].type === 'XVdropdown' ||
        questiontypes[questiontype].type === 'XVcheckboxlist' ||
        questiontypes[questiontype].type === 'XVsterrencontrol'
      ) {
        let datafilt = this.questionanswers[chapterindex].filter((o) => {
          return o.tblQuestionID === questionID
        })
        let datalist = []
        datafilt.forEach((item, key) => {
          datalist.push({
            value: item.tblDefaultAnswersID,
            labelText:
              item.tblDefaultAnswersScaleText === '' ? item.tblDefaultAnswersText : item.tblDefaultAnswersScaleText,
          })
        })

        proplist.datalist = datalist
      }

      if (
        questiontypes[questiontype].type === 'XVdropdown' ||
        questiontypes[questiontype].type === 'XVradiobuttonlistHorizontal'
      ) {
        proplist.placeholder = this.translation(14345)
      }

      return proplist
    },
    composeQuestion(item) {
      let questionText = ''
      questionText =
        item.textReplace === '' ? item.tblQuestionText : item.tblQuestionText.replace('##variable##', item.textReplace)
      questionText = item.tblQuestionchapterObligatory ? questionText + ' *' : questionText
      return questionText
    },
    nvtchangedclick: function (questionID, index, chapterindex) {
      this.$nextTick(() => {
        // nexttick nodig omdat anders de waarde niet altijd geset is (chrome en edge verschillen)
        this.nvtchanged({
          questionID: questionID,
          questionValue: null,
          nvtvalue: this.questionchoice[index].nvt,
          index: index,
          chapterid: chapterindex,
        })
        this.setstatetriggerquestion({
          vraagvalue: '',
          vraagid: questionID,
          chapterid: chapterindex,
        })
      })
    },
    formvaluechanged: function (fv) {
      // voor de checkboxlit de komma gescheiden waarde naar array omzetten

      let vraagid = Number(fv.id.replace('vraag', ''))

      // zoek het TblDefaultAnswersTextID op bij het antwoord
      let answerTextID = null
      let defaultAnswersScore = null
      if (fv.type === 'XVradiobuttonlist' || fv.type === 'XVradiobuttonlistHorizontal' || fv.type === 'XVdropdown') {
        let datafilt = this.questionanswers[fv.formdata.chapterindex].filter((o) => {
          return o.tblQuestionID === vraagid && o.tblDefaultAnswersID === fv.value
        })
        answerTextID = datafilt[0].tblDefaultAnswersTextID
        defaultAnswersScore = datafilt[0].tblDefaultAnswersScore
      }

      this.setstatetriggerquestion({
        vraagvalue: fv.value,
        vraagid: vraagid,
        chapterid: fv.formdata.chapterindex,
      })

      // sla de vraag op in de DB
      this.saveformvalue({
        id: vraagid,
        newvalue: fv.value,
        index: fv.formdata.index,
        answerTextID: answerTextID,
        defaultAnswersScore: defaultAnswersScore,
        type: fv.type,
      })
    },
    getcomp: function (questiontype) {
      return questiontypes[questiontype].type
    },
    validate: function () {
      this.$v.$touch()

      var valanchors = []
      var qc = this.$v.questionchoice
      for (let qcid in this.questionchoice) {
        if (qc[qcid].$invalid && this.questionchoice[qcid].nvt === false) {
          if (qc[qcid].value.required === false) {
            valanchors.push('rowanker' + qcid)
          }
          if (qc[qcid].value.isnumeric === false) {
            valanchors.push('rowanker' + qcid)
          }
          if (qc[qcid].value.minmaxnumber !== undefined && qc[qcid].value.minmaxnumber === false) {
            valanchors.push('rowanker' + qcid)
          }
        }
      }

      if (valanchors.length === 0) {
        this.valid = true
        util.newpageinit()
        this.setvalidationtriggered(false)
        if (
          this.evalformdata.chaptersOnOnePage === 0 &&
          this.chapters.length > 1 &&
          this.currentchapter < this.chapters.length - 1
        ) {
          this.nextchapter(false)
        } else {
          this.nextchapter(true)
        }

        this.$v.$reset()
      } else {
        this.setvalidationtriggered(true)
        this.valid = false
      }

      if (valanchors.length !== 0) {
        this.validateformmobile(
          this.translation(14268),
          this.translation(14322),
          valanchors[0],
          this.translation(14491)
        )
      }
    },
  },
  mounted: function () {
    this.getTexten()
    this.countquestions = 0

    EventBus.$on('chapterdataloaded', (newloading) => {
      if (newloading === 1) {
        this.show = true
        this.showchapter = true
      }
      if (newloading === 0) {
        this.showchapter = false
      }
    })
    // this.RESET()
    this.initialize()
  },
  components: {
    evaldowntrans,
    evaltrans,
    evalfadetrans,
    evalfinish,
    evalfooter,
  },
  validations: function () {
    if (this.questionchoice !== undefined) {
      let lv = Object.keys(this.questionchoice).reduce((listValidator, qcindex) => {
        let ci = this.questionchoice[qcindex].chapterindex
        if (this.$route.params.previewvalidations === 'false') {
          // preview voor beheer, kan geen gevens invullen en validaties staan uit zodat men erdoor heen kan bladeren
          listValidator[qcindex] = {}
        } else if (this.evalformdata.chaptersOnOnePage === 0 && this.computedchapters[0].chapterindex !== ci) {
          listValidator[qcindex] = {}
        } else {
          // setup validators, customvalidators are in Xvalidators.js (isnumericIf)
          listValidator[qcindex] = {
            value: {
              required: xValidation.NoSpacesRequiredIf((nestedModel) => {
                // gaat het om een triggerquestion?
                if (this.istriggerquestion(this.questionchoice[qcindex].questionID, ci) === true) {
                  // check of hij verplicht is en of de trigger question getriggered is
                  return (
                    this.questionchoice[qcindex].tblQuestionchapterObligatory === 1 &&
                    this.questionchoice[qcindex].questiontriggered === true
                  )
                } else {
                  // check of n.v.t. aan staat en de vraag verplicht is
                  return (
                    this.questionchoice[qcindex].nvt === false &&
                    this.questionchoice[qcindex].tblQuestionchapterObligatory === 1
                  )
                }
              }),
              isnumeric: xValidation.isnumericIf(this.questionchoice[qcindex].type === 'Number'),
            },
          }

          // als er een validatie vanuit de DB is ingesteld
          if (
            this.questionchoice[qcindex].tblQuestionValidateFunction !== null &&
            this.questionchoice[qcindex].tblQuestionValidateFunction !== ''
          ) {
            // console.log(this.questionchoice)
            // parse json object met validatie functie
            let custfuncpars = JSON.parse(this.questionchoice[qcindex].tblQuestionValidateFunction)

            // haal de validator vunctie op uit Xvalidator.js a.h.v. de naam van de functie uit de DB
            let fn = xValidation[custfuncpars.functie]

            // voeg de validator functie toe aan de value van het component
            listValidator[qcindex].value[custfuncpars.functie] = fn(custfuncpars.parameters)
          }
        }
        return listValidator
      }, {})
      return {
        questionchoice: lv,
      }
    } else {
      return {}
    }
  },
}
</script>

<style>
.peapp_default #Fixedactions {
}
</style>
